import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Typography,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button
} from '@mui/material';
import Header from '../../components/Header';

export default function AgentConfigPage() {
  const { id } = useParams();
  const [systemPrompt, setSystemPrompt] = useState('');
  const [services, setServices] = useState({
    email: false,
    calendar: false,
    calls: false,
    appointments: false
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    // TODO: fetch agent config by id and populate fields
    // e.g. fetch(`/api/agents/${id}/config`).then(res => res.json()).then(data => {
    //   setSystemPrompt(data.systemPrompt);
    //   setServices(data.services);
    // });
  }, [id]);

  const handleServiceChange = e => {
    const { name, checked } = e.target;
    setServices(prev => ({ ...prev, [name]: checked }));
  };

  const handleSave = () => {
    setSaving(true);
    const payload = { systemPrompt, services };
    // TODO: POST to backend or n8n webhook for saving the agent configuration
    // fetch(`/api/agents/${id}/config`, { method: 'POST', body: JSON.stringify(payload) })...
    setTimeout(() => setSaving(false), 1000); // stub
  };

  return (
    <Box m="20px">
      <Header title="Configure Agent" subtitle={`Settings for Agent ${id}`} />
      <Box mt={3}>
        <Typography variant="h6" gutterBottom>
          System Prompt
        </Typography>
        <TextField
          label="System Prompt"
          multiline
          rows={4}
          fullWidth
          variant="outlined"
          value={systemPrompt}
          onChange={e => setSystemPrompt(e.target.value)}
        />
      </Box>

      <Box mt={3}>
        <Typography variant="h6" gutterBottom>
          Enabled Services
        </Typography>
        <FormGroup>
          <FormControlLabel
            control={<Checkbox checked={services.email} onChange={handleServiceChange} name="email" />}
            label="Email"
          />
          <FormControlLabel
            control={<Checkbox checked={services.calendar} onChange={handleServiceChange} name="calendar" />}
            label="Calendar"
          />
          <FormControlLabel
            control={<Checkbox checked={services.calls} onChange={handleServiceChange} name="calls" />}
            label="Calls"
          />
          <FormControlLabel
            control={<Checkbox checked={services.appointments} onChange={handleServiceChange} name="appointments" />}
            label="Appointments"
          />
        </FormGroup>
      </Box>

      {/* Future: additional tool-specific config inputs here */}

      <Box mt={4}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? 'Saving...' : 'Save Configuration'}
        </Button>
      </Box>
    </Box>
  );
}
